import React from 'react';

/**
 * Componente de spinner para indicar carregamento
 */
const Spinner = ({
  size = 'md',
  color = 'primary',
  className = '',
  fullScreen = false,
  withText = false,
  text = 'Loading...',
  ...props
}) => {
  // Tamanhos disponíveis
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16',
  };
  
  // Cores disponíveis
  const colorClasses = {
    primary: 'text-primary-500',
    secondary: 'text-secondary-800',
    white: 'text-white',
    gray: 'text-gray-500',
  };
  
  // Aplicar classes
  const spinnerClasses = `
    animate-spin
    ${sizeClasses[size] || sizeClasses.md}
    ${colorClasses[color] || colorClasses.primary}
    ${className}
  `;
  
  // Renderizar spinner com ou sem texto
  const renderSpinner = () => (
    <div className={withText ? 'flex flex-col items-center' : ''}>
      <svg
        className={spinnerClasses}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      
      {withText && (
        <span className={`mt-2 text-sm font-medium ${colorClasses[color]}`}>{text}</span>
      )}
    </div>
  );
  
  // Se fullScreen, centralizar na tela
  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
        {renderSpinner()}
      </div>
    );
  }
  
  // Renderização padrão
  return renderSpinner();
};

export default Spinner; 